// CRM layer — the TRANSFER cell on the calls table (added Phase 6-C).
//
// Split out of CrmCallCell so the calls table has one column for opportunities
// and a separate one for handing a follow-up to another department or agent.
// Reuses CrmTransferModal unchanged.

import React, { useState, useEffect } from 'react';
import { FiSend } from 'react-icons/fi';
import { useAuth } from '../context/AuthContext';
import CrmTransferModal from './CrmTransferModal';
import { hasPerm } from './perms';
import { modalOpen, modalClosed } from './modalGuard';

const CrmTransferCell = ({ call, onChanged }) => {
  const { user } = useAuth();
  const [showTransfer, setShowTransfer] = useState(false);

  // Item 6: pause the host page's auto-refresh while the transfer modal is open.
  useEffect(() => {
    if (showTransfer) { modalOpen(); return () => modalClosed(); }
    return undefined;
  }, [showTransfer]);

  // A.5: only agents who may manage transfers can hand one over.
  if (!hasPerm(user, 'manage_transfers')) return null;

  return (
    <div className="crm-scope" style={{ minWidth: 92 }}>
      <button className="btn btn-outline btn-sm" style={{ fontSize: 11, padding: '2px 8px' }}
        title="تحويل متابعة هذا العميل لقسم أو موظف آخر"
        onClick={(e) => { e.stopPropagation(); setShowTransfer(true); }}>
        <FiSend size={12} /> تحويل
      </button>

      {showTransfer && (
        <CrmTransferModal
          phoneNumber={call.callerNumber}
          sourceCallId={call.id}
          onClose={() => setShowTransfer(false)}
          onDone={onChanged}
        />
      )}
    </div>
  );
};

export default CrmTransferCell;
